export default {
  trialBalanceCollection: [],
  trialBalanceFilter: '',
  trialBalanceStatus: null,
};
